
import { computed, defineComponent, inject } from "vue";
import { isInternalStaff, KeycloakLike } from "@/common/Roles";

export default defineComponent({
  name: "NavSidebar",
  props: ["show"],
  emits: ["logoutClick", "overlayClick"],
  setup() {
    // Hides the link from customers. The endpoint is what actually refuses
    // them - this only avoids offering a page they cannot open.
    const keycloak = inject<KeycloakLike | null>("keycloak", null);

    return {
      isInternalStaff: computed(() => isInternalStaff(keycloak)),
    };
  },
});
